import { Stack, type SxProps, type Theme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	bg: string;
	shape?: "rounded" | "circle";
	size?: number;
	children: ReactNode;
	sx?: SxProps<Theme>;
};

export const IconBox: FC<Props> = ({
	bg,
	shape = "rounded",
	size = 40,
	children,
	sx,
}) => (
	<Stack
		alignItems="center"
		justifyContent="center"
		flexShrink={0}
		width={size}
		height={size}
		bgcolor={bg}
		borderRadius={shape === "circle" ? "50%" : "12px"}
		sx={sx}
	>
		{children}
	</Stack>
);
